/** DVA namespace — must match `model.js` and route registration. */
export const MODEL_NAME = 'powerBiServers';

/** API route prefix — shared by `model.js` (createCrudModel) and list descriptor routes. */
export const FETCH_ROUTE = 'powerBIServerConfiguration';

/** Singular entity name for `createCrudModel` reducers/notifications. */
export const ENTITY_NAME = 'powerBiServer';

/** i18n resource key for form drawer hero summary (`configForm.hero.summary.resource.{key}.*`). */
export const FORM_RESOURCE_KEY = 'powerBiServers';
